import { render, staticRenderFns } from "./TableModal.vue?vue&type=template&id=2955020a"
import script from "./TableModal.vue?vue&type=script&lang=js"
export * from "./TableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports